import axios from 'axios';
import { loginreq, req,reqJson } from './axiosFun';

// 获取验证码
export const getCheckCode = (params) => { return req("get", "/api/ubiboat_website/user/smscode?phone="+params) };

export const signup = (params) => { return req("post", "/api/ubiboat_website/user/register", params) };
export const forgetPwd = (params) => { return req("post", "/api/ubiboat_website/user/forget_pwd", params) };

export const checkPhoneRegister = (params) => { return req("get", "/api/ubiboat_website/user/checkPhone?phoneNum="+params) };

export const checkAccountRegister = (params) => { return req("get", "/api/ubiboat_website/user/checkAccount?account="+params) };

export const changePhone = (params) => { return req("post", "/api/ubiboat_website/user/changephone", params) };

export const updatePwd = (params) => { return req("post", "/api/ubiboat_website/user/changepwd", params) };


export const updateAccountInfo = (params) => { return reqJson("/api/ubiboat_website/user/update", params) };

// 登录接口
export const login = (params) => { return loginreq("post", "/api/ubiboat_website/user/login", params) };

// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };



// WEBPACK FOOTER //
// ./src/api/userMG.js